
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cheero-redirect",
      function () {
        return require("private-next-pages/cheero-redirect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cheero-redirect"])
      });
    }
  